export const normalizeLoginStatusEmailKey = (email) => (email || '').trim();

export const shouldSkipLoginStatusFetch = (entry, { force = false } = {}) => {
	if (force) return false;
	if (!entry) return false;
	return entry.loading || (!entry.error && !!entry.status);
};

export const clearLoginStatusEntry = (state, email) => {
	const emailKey = normalizeLoginStatusEmailKey(email);
	if (!emailKey || !state[emailKey]) return state;
	const next = { ...state };
	delete next[emailKey];
	return next;
};

export const getLoginStatusRtkCacheKey = (email) =>
	`userLoginStatus-${normalizeLoginStatusEmailKey(email)}`;
